var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalogSubsetBannerSmall"},[_c('div',[_c('img',{staticClass:"siteMap__pageItemShape",attrs:{"src":require(`~/assets/img/catalog_subset_banner_small.svg`),"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"catalogSubsetBannerSmall__text"},[_vm._v("\n    Zachęcamy do przejrzenia oferty i rozpoczęcia zakupów w\n    "),_c('icon-link',{attrs:{"to":_vm.localePath({
          name: 'dashboard-catalog-subset',
        }),"text":"minikatalogu","icon":"chevron-right-bold"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }